/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Empirical_Linguistics27Inputs */

const en__field__enum_primarystudyinterest_study_empirical_linguistics27 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Empirical_Linguistics27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empirical Linguistics`)
};

const de__field__enum_primarystudyinterest_study_empirical_linguistics27 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Empirical_Linguistics27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empirische Sprachwissenschaften`)
};

/**
* | output |
* | --- |
* | "Empirical Linguistics" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Empirical_Linguistics27Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_empirical_linguistics27 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Empirical_Linguistics27Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Empirical_Linguistics27Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_empirical_linguistics27(inputs)
	return de__field__enum_primarystudyinterest_study_empirical_linguistics27(inputs)
});
export { _field__enum_primarystudyinterest_study_empirical_linguistics27 as "_field__enum_primaryStudyInterest_STUDY_EMPIRICAL_LINGUISTICS" }